// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiftref-accordion {
    background: var(--background-light);
    border: 1px solid var(--border-light);
    font-family: var(--p2-regular-font-family), sans-serif;
    font-size: var(--p2-regular-font-size);
    letter-spacing: var(--p2-regular-letter-spacing);
    line-height: var(--p2-regular-line-height);
    font-weight: var(--p2-regular-font-weight);
    transition: 50ms;
}
.swiftref-accordion .accordion-title {
    padding: var(--spacing-15) var(--spacing-30);
    padding-left: calc(var(--spacing-20) + var(--spacing-30) + 6px);
    border: none;
    width: 100%;
    text-align: left;
    cursor: pointer;
    position: relative;
    /*safari specific rule*/
    list-style: none;
}
.swiftref-accordion .accordion-title::marker,
.swiftref-accordion .accordion-title::-webkit-details-marker {
    content: none;
    display: none;
}


.swiftref-accordion .accordion-title::before {
    border-bottom: 2px solid var(--icon-light);
    border-right: 2px solid var(--icon-light);
    content: "";
    display: block;
    height: 6px;
    pointer-events: none;
    position: absolute;
    left: var(--spacing-30);
    /*top: 50%;*/
    top: 24px;
    transition: 200ms;
    transform: translate(0, -65%) rotate(-45deg);
    width: 6px;
}

.swiftref-accordion .accordion-title[aria-expanded="true"]::before {
    transform: translate(0, -65%) rotate(45deg);
}

.swiftref-accordion .accordion-content {
    background: var(--background-default);
    padding: var(--spacing-15) var(--spacing-30);
}
.swiftref-accordion .accordion-content[hidden],
.swiftref-accordion .accordion-content.hidden {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/accordion/style/index.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,sDAAsD;IACtD,sCAAsC;IACtC,gDAAgD;IAChD,0CAA0C;IAC1C,0CAA0C;IAC1C,gBAAgB;AACpB;AACA;IACI,4CAA4C;IAC5C,+DAA+D;IAC/D,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;;IAEI,aAAa;IACb,aAAa;AACjB;;;AAGA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,WAAW;IACX,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,4CAA4C;AAChD;AACA;;IAEI,aAAa;AACjB","sourcesContent":[".swiftref-accordion {\n    background: var(--background-light);\n    border: 1px solid var(--border-light);\n    font-family: var(--p2-regular-font-family), sans-serif;\n    font-size: var(--p2-regular-font-size);\n    letter-spacing: var(--p2-regular-letter-spacing);\n    line-height: var(--p2-regular-line-height);\n    font-weight: var(--p2-regular-font-weight);\n    transition: 50ms;\n}\n.swiftref-accordion .accordion-title {\n    padding: var(--spacing-15) var(--spacing-30);\n    padding-left: calc(var(--spacing-20) + var(--spacing-30) + 6px);\n    border: none;\n    width: 100%;\n    text-align: left;\n    cursor: pointer;\n    position: relative;\n    /*safari specific rule*/\n    list-style: none;\n}\n.swiftref-accordion .accordion-title::marker,\n.swiftref-accordion .accordion-title::-webkit-details-marker {\n    content: none;\n    display: none;\n}\n\n\n.swiftref-accordion .accordion-title::before {\n    border-bottom: 2px solid var(--icon-light);\n    border-right: 2px solid var(--icon-light);\n    content: \"\";\n    display: block;\n    height: 6px;\n    pointer-events: none;\n    position: absolute;\n    left: var(--spacing-30);\n    /*top: 50%;*/\n    top: 24px;\n    transition: 200ms;\n    transform: translate(0, -65%) rotate(-45deg);\n    width: 6px;\n}\n\n.swiftref-accordion .accordion-title[aria-expanded=\"true\"]::before {\n    transform: translate(0, -65%) rotate(45deg);\n}\n\n.swiftref-accordion .accordion-content {\n    background: var(--background-default);\n    padding: var(--spacing-15) var(--spacing-30);\n}\n.swiftref-accordion .accordion-content[hidden],\n.swiftref-accordion .accordion-content.hidden {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
